import {
  formattedColorMaterial,
  formattedWasteColor,
} from "../../../components/formatted/FormattedText";

/**
 * Extrait les données de flux pour un graphique
 */
export const extractFluxData = (data, targetFlux, t) => {
  const labels = [];
  const values = [];
  const colorSet = [];
  let total = 0;

  if (!data || typeof data !== "object") {
    return { labels, values, colorSet, total };
  }

  Object.entries(data).forEach(([material, anomalies]) => {
    if (!Array.isArray(anomalies)) return;
    const anomaly = anomalies.find((a) => a.flux === targetFlux);
    if (anomaly && material !== "unknown") {
      labels.push(t(material));
      values.push(anomaly.countAnomaly);
      colorSet.push(formattedColorMaterial(material));
      total += anomaly.countAnomaly;
    }
  });

  return { labels, values, colorSet, total };
};

/**
 * Extrait les données de caractérisation pour un graphique
 */
export const extractCharacterizationData = (data, targetFlux, t) => {
  const labelsData = [];
  const valuesData = [];
  const colorSetData = [];
  let materialTotal = 0;
  const result = {};

  if (!data || !Array.isArray(data)) {
    return { labelsData, valuesData, colorSetData, materialTotal };
  }

  data
    .filter((item) => item.label === targetFlux)
    .forEach((item) => {
      Object.entries(item.wasteData).forEach(([material, value]) => {
        if (material !== "unknown") {
          if (!result[material]) {
            result[material] = 0;
          }
          result[material] += value;
        }
      });
    });

  Object.entries(result).forEach(([material, value]) => {
    labelsData.push(t(material));
    valuesData.push(value);
    colorSetData.push(formattedColorMaterial(material));
    materialTotal += value;
  });

  return { labelsData, valuesData, colorSetData, materialTotal };
};

/**
 * Construit les datasets pour le graphique de distribution des erreurs de tri par flux
 */
export const buildSortingErrorByFluxChartData = (data, t) => {
  const dataSetsSortingErrorByFluxChart = [];
  const labelsByTimeChart = [];

  if (!data || typeof data !== "object") {
    return { dataSetsSortingErrorByFluxChart, labelsByTimeChart };
  }

  Object.keys(data).forEach((flux) => {
    const monthlyDistribution = Array.isArray(data?.[flux]?.monthlyDistribution)
      ? data[flux].monthlyDistribution
      : [];

    dataSetsSortingErrorByFluxChart.push({
      label: flux,
      data: monthlyDistribution.map((item) => ({
        x: item.time,
        y: item.countAnomalies,
        z: flux,
      })),
      backgroundColor: formattedWasteColor(flux),
      type: "bar",
    });

    for (let i = 0; i < monthlyDistribution.length; i++) {
      if (!labelsByTimeChart.includes(monthlyDistribution[i].time)) {
        labelsByTimeChart.push(monthlyDistribution[i].time);
      }
    }
  });

  return { dataSetsSortingErrorByFluxChart, labelsByTimeChart };
};
